import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/utils/axiosInstance";
import { Params } from "@/types";
import { handleThunkError } from "@/utils/thunkErrorHandler";

const endpoint = {
  clientGroup: "/client-groups",
};

export const fetchGroups = createAsyncThunk(
  "groups/fetchGroups",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.clientGroup, {
        params,
      });
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Erro ao carregar grupos de clientes",
      );
    }
  },
);

export const createGroup = createAsyncThunk(
  "groups/createGroup",
  async (groupsData: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoint.clientGroup,
        groupsData,
      );
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Erro ao criar grupo de cliente",
      );
    }
  },
);

export const updateGroup = createAsyncThunk(
  "groups/updateGroups",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint.clientGroup}/${data.slug}`,
        data,
      );
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Erro ao atualizar grupo de cliente",
      );
    }
  },
);

export const deleteGroup = createAsyncThunk(
  "groups/deleteGroup",
  async (slug: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${endpoint.clientGroup}/${slug}`,
      );
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Erro ao excluir grupo de cliente",
      );
    }
  },
);
